import { apiClient } from "@/service/ApiClient";

/* =======================
 * DTO / RESPONSE TYPE
 * ======================= */

export interface AttendStatDto {
    ranking: number;
    name: string;
    attendGameCnt: number;
    totalGameCnt: number;
    attendRatio: number;
}

export interface PointStatDto {
    ranking: number;
    name: string;
    winCnt: number;
    drawCnt: number;
    loseCnt: number;
    totalPoint: number;
}

export interface AttackStatDto {
    ranking: number;
    name: number;
    goal: number;
    assist: number;
    attackPoint: number;
}

/* =======================
 * API
 * ======================= */

/**
 * 참석률 랭킹 조회
 */
const getAttendStats = async (year: number, month: string) =>
    apiClient
        .get<AttendStatDto[]>(`/game/stats/attend`, {
            params: { year, month }
        })
        .then(res => res.data);

/**
 * 승점 랭킹 조회
 */
const getPointStats = async (year: number, month: string) =>
    apiClient
        .get<PointStatDto[]>(`/game/stats/point`, {
            params: { year, month  }
        })
        .then(res => res.data);

/**
 * 공격 포인트 랭킹 조회
 */
const getAttackStats = async (year: number, month: string) =>
    apiClient
        .get<AttackStatDto[]>(`/game/stats/attack`, {
            params: { year, month  }
        })
        .then(res => res.data);

/* =======================
 * EXPORT
 * ======================= */

const StatService = {
    getAttendStats,
    getPointStats,
    getAttackStats
};

export default StatService;
